/**
 * Attend qu'un élément apparaisse dans le DOM, jusqu'à `timeoutMs`, puis rend
 * `null`. Une visite part souvent d'une navigation : l'écran visé charge encore
 * ses données, et ses ancres n'existent pas au moment où l'on voudrait démarrer.
 */
export function waitForElement(selector: string, timeoutMs: number): Promise<Element | null> {
  const found = document.querySelector(selector)
  if (found) return Promise.resolve(found)

  return new Promise((resolve) => {
    let observer: MutationObserver | null = null
    const timer = setTimeout(() => {
      observer?.disconnect()
      resolve(null)
    }, timeoutMs)
    observer = new MutationObserver(() => {
      const element = document.querySelector(selector)
      if (element) {
        observer?.disconnect()
        clearTimeout(timer)
        resolve(element)
      }
    })
    observer.observe(document.body, { childList: true, subtree: true })
  })
}
